<template>
	<preloader v-if="loading" />
	<div class="page" v-else>
		<b-button class="btn-language" variant="link" @click="showLanguageModal = true">
			<i class="fa fa-language" aria-hidden="true"></i>
			{{ $t('Language') }}
		</b-button>
		<b-modal size="sm" hide-footer v-model="showLanguageModal" :title="$t('Select language')">
			<a v-for="[lng, label] in LANGUAGES" :key="lng" class="d-block m-auto" href="#" @click="changeLang(lng)">
				{{ label }}
			</a>
		</b-modal>
		<div class="container ">
			<router-link to="/" class="logo">
				<img src="../../assets/logo_en_sm.svg" alt="Indigo Logo" />
			</router-link>

			<div class="d-flex justify-content-between align-items-center">
				<button v-if="!edit && myRole === 'super franchise'" @click="edit = !edit" class="btn btn-secondary">
					{{ 'Edit' | translate }}
				</button>
			</div>
			<div v-if="edit">
				<form class="form-horizontal" action="" method="post">
					<div class="tabs">
						<button v-for="language in languages" :key="language" @click.prevent="tab = language"
							:class="{ active: tab === language }" class="btn">
							{{ language.toUpperCase() | translate }}
						</button>
					</div>
					<div class="tab-content">
						<vue-editor v-for="language in languages" :key="language" :id="`editor-${language}`"
							:editorToolbar="toolbar" v-show="tab === language" v-model="text[language]" />
					</div>
					<div class="text-center">
						<button @click.prevent="sendText" class="btn btn-primary">
							{{ 'Save' | translate }}
						</button>
					</div>
				</form>
			</div>
			<div v-if="!edit" v-html="baseText" />
		</div>
	</div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import Preloader from '@/components/Preloader'
// import VueEditor from 'vue-trix'

export default {
	name: 'dashboard-static',
	data() {
		return {
			showLanguageModal: false,
			languages: [
				'en',
				'ru',
				'ua',
				'pl',
				'he',
				'az',
				'ro',
				'hy',
				'fr',
				'es',
				'cs',
				'de',
				'it',
				'tr',
				'el',
			],
			text: {
				en: null,
				ru: null,
				ua: null,
				pl: null,
				he: null,
				az: null,
				ro: null,
				hy: null,
				fr: null,
				es: null,
				cs: null,
				de: null,
				it: null,
				tr: null,
				el: null,
			},
			loading: true,
			myRole: this.$store.state.myProfile?.role,
			edit: false,
			tab: 'ru',
			toolbar: [
				['bold', 'italic', 'underline', 'strike'],
				['blockquote', 'code-block', 'image', 'video'],
				[{ list: 'ordered' }, { list: 'bullet' }],
				[{ indent: '+1' }, { indent: '-1' }],
				[{ header: [1, 2, 3, 4, 5, 6, false] }],
				[{ color: [] }],
				[{ font: [] }],
				[{ align: [] }],
			],
		}
	},
	components: {
		Preloader,
		VueEditor,
	},
	computed: {
		isDisabledButton() {
			return (
				this.text.en &&
				this.text.ru &&
				this.text.ua &&
				this.text.pl &&
				this.text.he &&
				this.text.az &&
				this.text.ro &&
				this.text.hy &&
				this.text.fr &&
				this.text.es &&
				this.text.cs &&
				this.text.de &&
				this.text.it &&
				this.text.tr &&
				this.text.el
			)
		},
		baseText() {
			let lng = this.$i18n.locale()

			if (lng === 'uk') lng = 'ua'

			// Set text with selected lng or ua text by default
			let text = this.text[lng]

			if (text) {
				text = this.text[lng]
			} else {
				text = this.text.en
			}

			return text
		},
		LANGUAGES: () => [
			['en', 'English'],
			['ru', 'Русский'],
			['ua', 'Українська'],
			['pl', 'Polski'],
			['he', 'עברית'],
			['az', 'Azərbaycan'],
			['ro', 'Română '],
			['hy', 'հայերեն'],
			['fr', 'Français'],
			['es', 'Español'],
			['cs', 'Czech'],
			['de', 'Deutsch'],
			['it', 'Italiano'],
			['tr', 'Türkçe'],
			['el', 'Ελληνικά'],
		],
	},
	methods: {
		handleFile(file) { },

		handleAttachmentRemove(file) { },
		changeLang(locale) {
			window.localStorage.setItem('defaultLanguage', locale)
			this.$i18n.set(locale)
			this.showLanguageModal = false
		},
		async sendText() {
			this.loading = true
			await this.axios({
				method: 'post',
				url: `pages/${this.$route.params.static}`,
				data: {
					text_az: this.text.az,
					text_uk: this.text.ua,
					text_en: this.text.en,
					text_pl: this.text.pl,
					text_he: this.text.he,
					text_ru: this.text.ru,
					text_ro: this.text.ro,
					text_hy: this.text.hy,
					text_fr: this.text.fr,
					text_es: this.text.es,
					text_cs: this.text.cs,
					text_de: this.text.de,
					text_it: this.text.it,
					text_tr: this.text.tr,
					text_el: this.text.el,
				},
			})
			this.loading = false
			this.edit = false
		},
		async updateText() {
			this.loading = true
			await this.axios({
				method: 'get',
				url: `pages/${this.$route.params.static}`,
			})
				.then(({ data }) => {
					this.text.ua = data.text_uk
					this.text.en = data.text_en
					this.text.ru = data.text_ru
					this.text.pl = data.text_pl
					this.text.he = data.text_he
					this.text.az = data.text_az
					this.text.ro = data.text_ro
					this.text.hy = data.text_hy
					this.text.fr = data.text_fr
					this.text.es = data.text_es
					this.text.cs = data.text_cs
					this.text.de = data.text_de
					this.text.it = data.text_it
					this.text.tr = data.text_tr
					this.text.el = data.text_el
					this.loading = false
				})
				.catch(({ response }) => {
					if (response?.status === 400) {
						this.$router.push({ name: 'Dashboard 404' })
					}
					this.loading = false
				})
		},
	},
	beforeMount() {
		this.updateText()

		console.log(this.text)
	},
	watch: {
		$route(to, from) {
			this.updateText()
		},
	},
}
</script>

<style>
.ql-align-center {
	text-align: center;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-language {
	position: absolute;
	top: 16px;
	right: 16px;
	color: #333;
	font-size: 20px;
}

.btn-language:hover {
	color: #e69c50;
}

.logo {
	width: 120px;
	height: auto;
	margin: 0 auto 0;
	display: block;
}

.container {
	padding-top: 20px;
	padding-bottom: 20px;
}

.btn-primary {
	margin: 10px;
}

.tabs .active {
	background-color: #67bc50;
}

.page {
	background: #fff url(~@/assets/back-white.png) center 0 no-repeat;
	min-height: 100vh;
	position: relative;
}
</style>
